import { FC } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { RootState } from '../../../store/rootReducer';
import { DatePicker, Select, Table, TableColumnsType } from 'antd';

import moment from 'moment';
const { Option } = Select;

interface IProps {
  monthInput: any;
  setMonthInput: Function;
  isDisabled: boolean;
}

const SemesterMonth: FC<IProps> = ({
  monthInput,
  setMonthInput,
  isDisabled,
}) => {
  const { t, i18n } = useTranslation();
  const { commonCodes } = useSelector((state: RootState) => state.commonCode);
  // SY0009 = 월 정보
  const SY0009 = commonCodes.find(item => item.commonCode === 'SY0009')?.detailCode;

  const onSetMonthInput = (key: string, value: any) => {
    setMonthInput({ ...monthInput, [key]: value });
  }

  const columns: TableColumnsType<any> = [
    {
      title: t('program.semester.column14'),
      dataIndex: 'id',
      key: 'id',
      align: 'center'
    },
    {
      title: t('program.semester.column15'),
      dataIndex: 'nameKey',
      key: 'nameKey',
      render: value => (
        <Select
          className="w-100"
          placeholder={t('common.button.select')}
          value={monthInput[value]}
          onChange={e => onSetMonthInput(value, e)}
          disabled={isDisabled}
        >
          {
            SY0009?.map((item: any) => {
              return (
                <Option
                  key={item.detailCode}
                  value={item.detailCode}
                >
                  {i18n.language === 'ko' ? item.korName : item.engName}
                </Option>
              )
            })
          }
        </Select>
      ),
      align: 'center'
    },
    {
      title: t('program.semester.column12'),
      dataIndex: 'startKey',
      key: 'startKey',
      render: value => (
        <div className="date-picker__area">
          <DatePicker
            value={
              monthInput[value]
                ? moment(monthInput[value])
                : undefined
            }
            onChange={e => {
              if (e === null) onSetMonthInput(value, null);
              else onSetMonthInput(value, moment(e).format('YYYY-MM-DD'));
            }}
            disabled={isDisabled}
          />
        </div>
      ),
      align: 'center'
    },
    {
      title: t('program.semester.column13'),
      dataIndex: 'endKey',
      key: 'endKey',
      render: value => (
        <div className="date-picker__area">
          <DatePicker
            value={
              monthInput[value]
                ? moment(monthInput[value])
                : undefined
            }
            onChange={e => {
              if (e === null) onSetMonthInput(value, null);
              else onSetMonthInput(value, moment(e).format('YYYY-MM-DD'));
            }}
            disabled={isDisabled}
          />
        </div>
      ),
      align: 'center'
    },
    {
      title: t('program.semester.column16'),
      dataIndex: 'statsKey',
      key: 'statsKey',
      render: (value: string) => (
        <div className="date-picker__area">
          <DatePicker
            value={
              monthInput[value]
                ? moment(monthInput[value])
                : undefined
            }
            onChange={e => {
              if (e === null) onSetMonthInput(value, null);
              else onSetMonthInput(value, moment(e).format('YYYY-MM-DD'));
            }}
            disabled={isDisabled}
          />
        </div>
      ),
      align: 'center'
    },
  ];

  const data = [
    {
      id: 1,
      nameKey: 'monthName1',
      startKey: 'startDate1',
      endKey: 'endDate1',
      statsKey: 'statsDate1',
    },
    {
      id: 2,
      nameKey: 'monthName2',
      startKey: 'startDate2',
      endKey: 'endDate2',
      statsKey: 'statsDate2',
    },
    {
      id: 3,
      nameKey: 'monthName3',
      startKey: 'startDate3',
      endKey: 'endDate3',
      statsKey: 'statsDate3',
    },
  ];

  return (
    <div>
      <Table
        className='comm-table__area'
        columns={columns}
        dataSource={data}
      />
    </div>
  );
}

export default SemesterMonth;
